import { Divider, Typography } from "@mui/material"
import type { FC } from "react"

import { FilterCheckbox } from "@/components/common/Filters"
import type { ComputedProductStatus } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

interface ProductInventoryProductStatusFilterProps {
  control: any
  values: ComputedProductStatus[]
  options: Option<ComputedProductStatus>[]
  onChange: (values: ComputedProductStatus[]) => void
}

export const ProductInventoryProductStatusFilter: FC<ProductInventoryProductStatusFilterProps> = ({
  control,
  values,
  options,
  onChange,
}) => {
  return (
    <div data-testid='product-inventory.product-status-filter'>
      <Typography variant='subtitle1' fontWeight={700} className='px-4 py-1.5 text-gray-700'>
        Product Status
      </Typography>
      <Divider className='mb-4' />
      <div className='flex flex-col px-4'>
        {options.map((option) => (
          <FilterCheckbox
            key={option.value}
            control={control}
            name='productStatuses'
            value={option.value}
            values={values}
            label={option.label}
            onFilterChange={(values) => onChange(values as ComputedProductStatus[])}
            data-testid={`product-inventory.product-status-filter.option-${option.value}`}
          />
        ))}
      </div>
    </div>
  )
}
